import React from "react";
import cs from "classnames";

import { Box, IconButton } from "@braintrust/braintrust-ui-components";
import {
  ClearIcon,
  EditPencilIcon,
} from "@braintrust/braintrust-ui-components/Icons";

import styles from "./styles.module.scss";

type AttachmentActionsWrapperProps = {
  onRemoveClick: (() => void) | undefined;
  removeAriaLabel?: string;
  onEditLinkClick?: () => void;
  showBorder?: boolean;
  roundedBorder?: boolean;
  isFromText?: boolean;
};

export const AttachmentActionsWrapper: React.FC<
  React.PropsWithChildren<AttachmentActionsWrapperProps>
> = ({
  onRemoveClick,
  removeAriaLabel,
  onEditLinkClick,
  showBorder,
  roundedBorder,
  children,
  isFromText,
}) => {
  const showClearIcon = !!onRemoveClick;
  const removeButtonAriaLabel: string = removeAriaLabel ?? "Remove attachment";

  return (
    <Box
      className={cs(styles.wrapper, {
        [styles["wrapper-border"]]: showBorder,
        [styles["rounded"]]: roundedBorder,
        [styles["editMode"]]: onEditLinkClick && !isFromText,
      })}
    >
      {children}
      {showClearIcon && onRemoveClick && (
        <IconButton
          type="button"
          onClick={onRemoveClick}
          data-testid="remove-attachment-button"
          aria-label={removeButtonAriaLabel}
          variant="transparent"
          size="x-small"
          className={styles.closeIcon}
        >
          <ClearIcon />
        </IconButton>
      )}

      {onEditLinkClick && !isFromText && (
        <EditPencilIcon onClick={onEditLinkClick} className={styles.editIcon} />
      )}
    </Box>
  );
};
